import { useContext, useState } from "react"
import { VibratoClientContext } from "./contexts"

export default function EmailNotVerified() {
  const vibratoClient = useContext(VibratoClientContext)
  const [showSent, setShowSent] = useState(false)

  const sentDiv = (
    <div className="text-lg md:text-2xl font-thin italic text-gray-700 mt-4 max-w-lg text-center">Sent.</div>
  )

  return (
    <section>
      <div className="h-screen w-screen bg-gray-100 ">
        <div className="h-full w-full">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div className="flex flex-col justify-center items-center">
              <img src="/vibrato-logo-alt.svg" className="h-[50px] md:h-[80px] min-w-fit mb-8" />
              <div className="text-xl md:text-4xl font-bold text-gray-700">Your email is not verified</div>
              <div className="text-lg md:text-2xl font-normal text-gray-700 mt-4 max-w-lg text-center">
                Please check your email for a verification link.
              </div>
              <div className="text-lg md:text-2xl font-normal text-gray-700 mt-4 max-w-md text-center">
                Click{" "}
                <a
                  onClick={() => {
                    try {
                      vibratoClient.resendEmailVerification()
                      setShowSent(true)
                    } catch (e) {
                      console.log(e)
                    }
                  }}
                  className="text-blue-500 hover:text-blue-700 cursor-pointer"
                >
                  here
                </a>{" "}
                to resend the verification email.
              </div>
              <div className="text-lg md:text-2xl font-normal text-gray-700 mt-4 max-w-md text-center">
                Or, if you want to log out, click{" "}
                <a href="/logout" className="text-blue-500 hover:text-blue-700 cursor-pointer">
                  here
                </a>
                .
              </div>
              {showSent && sentDiv}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
